package com.ilussobsa.utils

import com.ilussobsa.Resources
import com.ilussobsa.Strings
import com.ilussobsa.views.PrivacyPolicyScreen
import com.ilussobsa.views.TermsOfUseScreen
import com.lightningkite.kiteui.models.Align
import com.lightningkite.kiteui.models.BarSemantic
import com.lightningkite.kiteui.models.ImageScaleType
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*

fun ViewWriter.footer(): ViewModifiable {
    return BarSemantic.onNext- compact - row {
        centered - sizeConstraints(height = 3.rem, width = 9.rem) - image {
            scaleType = ImageScaleType.Fit
            source = Resources.ilussoFullLogo(defaultAppTheme)
            description = Strings.appName
        }
        space()
        centered - subtext("© 2025 iLusso")
        centered - subtext(" |")
        centered - compact - link {
            subtext {
                align = Align.Center
                content = Strings.privacyPolicy
            }
            to = { PrivacyPolicyScreen() }
        }
        centered - subtext(" |")
        centered - compact - link {
            subtext {
                align = Align.Center
                content = Strings.termsOfUse
            }
            to = { TermsOfUseScreen() }
        }
    }
}